import caseStudies from "../src/data/case-study.json"

export interface CaseStudyContent {
  slug: string;
  title: string;
  date: string;
  description: string;
  image: string;
  pdfPath: string;
}

export const CASE_STUDIES: CaseStudyContent[] = caseStudies;

export const CASE_STUDY_SLUG_ROUTES = CASE_STUDIES.map(
  (caseStudy) => `/case-study/${caseStudy.slug}`,
);

export const CASE_STUDIES_BY_SLUG = Object.fromEntries(
  CASE_STUDIES.map((caseStudy) => [caseStudy.slug, caseStudy] as const),
) as Record<string, CaseStudyContent>;
